import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import NavBarLayout, { NavBarRoute } from '../NavBarLayout';
import UserProfile from './UserProfile';
import UserPurchases from './UserPurchases';
import ErrorPage from '../ErrorPage';
import {getBootstrapConfig, getUserInfo, isUserLogged} from '../../reducers';
import {authShowLogin} from '../../actions/creators'
import {logout} from '../../actions/creators/auth';
import UserWallet from './UserWallet';
import UserDeleteAccount from './UserDeleteAccount';
import { deleteAccount } from '../../actions/creators/user';
import UserSessionsList from './UserSessionsList';
import IERegistrationPage from '../IERegistrationPage';
import IEMigrationPage from '../IEMigrationPage';
import { hasIeAction } from '../../utils/misc';
import UserCoupons from './coupons/UserCoupons';
import RequireAuthMessage from './RequireAuthMessage';
import UserCandybarPurchases from './UserCandybarPurchases';
import PackagesPage from './loyalty/PackagesPage';
import UserWalletListPage from './UserWallet/UserWalletList/UserWalletListPage';
import UserWalletBuy from './UserWallet/UserWalletBuy/UserWalletBuy';
import UserWalletBuyByType from './UserWallet/UserWalletBuy/UserWalletBuyByType';
import UserWalletAddCard from './UserWallet/UserWalletAddCard/UserWalletAddCard';

interface Props {
  history: any;
  isUserLogged: boolean;
  location: any;
  user: any;
  wallet: string;
  authShowLogin: () => void;
  deleteAccount: (history: any, params: any) => void;
  logout: () => void;
}

class UserPage extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.deleteAccount = this.deleteAccount.bind(this);
  }

  render() {
    if (!this.props.isUserLogged) {
      return <ErrorPage>{this.renderNoUserLogged()}</ErrorPage>;
    }

    const routes: Array<NavBarRoute> = [
      {
        title: 'Mis datos',
        component: UserProfile,
        path: ['/usuario/', '/usuario/cambiar-nip/'],
        showTitle: false,
      },
      {
        title: 'Historial de compras',
        component: UserPurchases,
        path: '/usuario/mis-compras',
      },
      {
        title: 'Pedidos de dulcería',
        component: UserCandybarPurchases,
        path: '/usuario/mis-compras/dulceria',
        defaultBodyClass: '',
      },
      {
        title: 'Boletos activos',
        render: () => <UserPurchases future={true}/>,
        path: '/usuario/mis-compras/tickets-activos',
        showSectionTitle: false,
      },
      {
        title: 'Wallet',
        render: () => <UserWalletListPage />,
        path: '/usuario/wallet',
        showSectionTitle: false,
        nav: false,
      },
      {
        title: 'Comprar tarjetas',
        render: () => <UserWalletBuy />,
        path: '/usuario/wallet/comprar',
        showSectionTitle: false,
        showTitle: false,
        nav: false,
      },
      {
        title: 'Comprar tarjetas',
        render: () => <UserWalletBuyByType />,
        path: '/usuario/wallet/comprar/:type',
        showSectionTitle: false,
        showTitle: false,
        nav: false,
      },
      {
        title: 'Agregar tarjeta',
        render: () => <UserWalletAddCard />,
        path: '/usuario/wallet/agregar',
        showSectionTitle: false,
        showTitle: false,
        nav: false,
      },
      {
        title: 'Cupones',
        component: UserCoupons,
        path: '/usuario/cupones',
        showSectionTitle: false,
      },
    ];
  
    if (this.props.wallet === 't1') {
      routes.push({
        title: 'Mis tarjetas',
        showTitle: false,
        component: UserWallet,
        path: '/usuario/mis-tarjetas',
      });
    }

    if (this.props.user) {
      routes.push({
        title: 'Inscripción Cinemex Loop',
        component: IERegistrationPage,
        path: '/usuario/loop/inscripcion',
        defaultBodyClass: '',
        nav: !this.props.user.iecode && hasIeAction(this.props.user, 'sign-up')
      });

      if (this.props.user.iecode) {
        routes.push({
          title: 'Cambia tu tarjeta Cinemex Loop',
          render: () => <IEMigrationPage action='ie-migration'/>,
          path: '/usuario/loop/migracion',
          defaultBodyClass: '',
          nav: this.props.user.migration_available
        });

        routes.push({
          title: 'Cambio de Nivel Cinemex Loop',
          render: () => <IEMigrationPage action='ie-renewal'/>,
          path: '/usuario/loop/renovacion',
          defaultBodyClass: '',
          nav: false
        });

        routes.push({
          title: 'Cambio de Nivel Cinemex Loop',
          render: () => <IEMigrationPage action='ie-renewal'/>,
          path: '/usuario/loop/cambio-de-nivel',
          defaultBodyClass: '',
          nav: this.props.user.renewal_available
        });

        routes.push({
          title: 'Venta de paquetes',
          component: PackagesPage,
          path: '/usuario/loop/paquetes',
        });
      }
    }
    
    routes.push({
      title: 'Dispositivos vinculados',
      showTitle: false,
      render: () => <UserSessionsList />,
      path: '/usuario/sesiones-activas',
      nav: false
    });
  
    routes.push({
      title: 'Eliminar cuenta',
      showTitle: false,
      render: () => <UserDeleteAccount onSubmit={this.deleteAccount} />,
      path: '/usuario/eliminar-cuenta',
    });
  
    routes.push({
      title: 'Cerrar sesión',
      onClick: this.props.logout,
    });

    return <NavBarLayout fixedTitle="Perfil" routes={routes}/>;
  }

  renderNoUserLogged() {
    if (this.props.location.pathname.indexOf('/tickets-activos') >= 0) {
      return <RequireAuthMessage>
        <p>Para guardar y ver tus boletos activos, primero debes iniciar sesión.</p>
      </RequireAuthMessage>;
    }
    
    if (this.props.location.pathname.indexOf('/cupones') >= 0) {
      return <RequireAuthMessage>
          <p>Para activar y canjear cupones, primero debes inciar sesión.</p>
        </RequireAuthMessage>;
    }

    return <RequireAuthMessage icon='fa-circle-exclamation'>
      <p>Debes iniciar sesión para acceder a esta sección.</p>
    </RequireAuthMessage>;
  }

  deleteAccount(params) {
    this.props.deleteAccount(this.props.history, params);
  }

}

const mapStateToProps = state => ({
  isUserLogged: isUserLogged(state),
  wallet: getBootstrapConfig(state).wallet,
  user: getUserInfo(state)
});

const mapDispatchToProps = dispatch => ({
  authShowLogin: () => dispatch(authShowLogin()),
  logout: () => dispatch(logout()),
  deleteAccount: (history, params) => dispatch(deleteAccount(history, params)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserPage));